"use client";

import { Agentation } from "agentation";

const AGENTATION_SYNC_ENDPOINT =
  process.env.NODE_ENV === "development" ? "http://localhost:4747" : undefined;

export function DevAgentation() {
  return <Agentation endpoint={AGENTATION_SYNC_ENDPOINT} />;
}
